<template>
  <div :key="$store.getters['resource/currentResource'].key">

    <help :text="$t('help.transactions')" :title="$t('help.transactions_title')"/>

    <filters
      class="white-container transactions-filter"
      v-if="filters"
      :inputs="filters"
      @filter="filter"
      :extendButton="false"
      :extended="true"
      globalFilter="users.global"
      :loading="loading"
    >
    </filters>

    <div class="position-relative">

      <loader v-if="loading"/>

      <v-server-table
        ref="appTable"
        name="transactionsTable"
        class="white-container"
        url="/admin/transactions"
        :columns="columns"
        :options="options"
        @loaded="loading = false"
        @loading="loading = true">

        <template slot="beforeFilter">

          <div class="w-100 d-flex flex-row flex-wrap">
          <div>
          <router-link to="/transactions/create">
            <b-button
                class="px-4 mb-3"
            >{{ $t('transactions.add_new_transaction') }}
            </b-button>
          </router-link>
        </div>
          <div class="mt-2 d-flex flex-row align-items-start ml-4">
            <i class="far fa-file-excel fa-lg mr-1 text-primary d-block"></i>
            <b-link @click="exportList({filter: params, download: true}, 'transactions')">
              {{$t('global.export')}}
            </b-link>
          </div>
    </div>

        </template>

        <template slot="afterTable">
          <div class="mt-3">
            <span>{{$t('transactions.total_amount')}}: <span class="text-primary">{{formatToDollars(filteredAmount).toLocaleString()}}</span></span>
          </div>
        </template>

        <template slot="beforeLimit" v-if="totalRecordsCount > 10">
          {{$t('global.showing')}}&nbsp;
        </template>
        <template slot="afterLimit" v-if="totalRecordsCount > 10">
          &nbsp;{{$t('global.of_records_found', {number: totalRecordsCount})}}
        </template>
        <template slot="id" slot-scope="props">
          <router-link
            :to="{path: `/transactions/info/${props.row.id}`, params: props.row}">
            {{props.row.id}}
          </router-link>
        </template>
        <template slot="user" slot-scope="props">
          <column-name :row="props.row" column="user"/>
        </template>
        <template slot="amount" slot-scope="props">
          <cents-to-bills :row="props.row" column="amount" :currency="true"/>
        </template>
        <template slot="price" slot-scope="props">
          <cents-to-bills :row="props.row" column="price" :currency="true"/>
        </template>
        <template slot="processing_fees" slot-scope="props">
          <cents-to-bills :row="props.row" column="processing_fees" :currency="true"/>
        </template>
        <template slot="status" slot-scope="props">
          <column-check :row="props.row" column="status" active="succeeded"/>
        </template>
        <template slot="created_at" slot-scope="props">
          <column-date :row="props.row" column="created_at" format="L, h:mm:ss a"/>
        </template>
        <template slot="processing_vat" slot-scope="props">
          <cents-to-bills :row="props.row" column="processing_vat" :currency="true"/>
        </template>
        <template slot="receipt_actions" slot-scope="props">
          <column-receipt-actions :transaction="props.row"/>
        </template>
        <template slot="actions" slot-scope="props">
          <column-action
              :deleteDisabled="props.row.pay_system !== 'manual'"
              :showEditButton="false"
              :deleteUrl="`/transactions/${props.row.id}`"
              @deleteItems="refreshTable('appTable')"/>
        </template>
      </v-server-table>
    </div>
  </div>

</template>

<script>
  import axios from '@/utils/axios';
  import {Event} from 'vue-tables-2';
  import transactionsFilters from './transactionsFilters.js';
  import filters from '@/components/global/filters';
  import i18n from "@/utils/i18n";
  import ColumnReceiptActions from '@/components/table/ColumnReceiptActions';

  export default {
    middleware: 'auth',
    name: 'Transactions',
    components: {
      filters,
      ColumnReceiptActions
    },
    data: () => {
      return {
        loading: false,
        totalRecordsCount: null,
        filteredAmount: 0,
        params: {
          page: 1,
          filter: {}
        },
        columns: ['id', 'user', 'amount', 'price', 'processing_fees',
          'processing_vat', 'created_at', 'status', 'receipt_actions', 'actions'],
        filters: transactionsFilters,
        options: {
          skin: [],
          headings: {
            id: '#',
            user: i18n.t('users.user'),
            pay_system: i18n.t('transactions.payment_system'),
            amount: i18n.t('transactions.amount'),
            processing_fees: i18n.t('transactions.processing_fees'),
            processing_vat: i18n.t('transactions.vat'),
            created_at: i18n.t('transactions.date_&_time'),
            status: i18n.t('form.status'),
            receipt_actions: i18n.t('transactions.receipt.receipt_actions'),
            actions: i18n.t('global.actions'),
          },
          sortable: [],
          dateColumns: ['created_at'],
          columnsDropdown: false,
          filterByColumn: false,
          customFilters: ['custom'],
          perPage: !!localStorage.getItem('perPage') && localStorage.getItem('perPage') !== '' ? localStorage.getItem('perPage') : 10,
          filterable: false,
          requestFunction: function (data) {
            localStorage.setItem('perPage', data.limit);
            return axios.get(this.url, {
              params: {
                filter: data.custom,
                limit: data.limit,
                page: data.page
              }
            }).catch((e) => {
              // this.$noty.error(e.error_description);
              this.dispatch('error', e);
            });
          },
          responseAdapter: function (resp) {
            let data = this.getResponseData(resp);
            let items = [];
            if (Array.isArray(data.data.items)) {
              items = data.data.items.map((item) => {
                if(item.processing_fee_payment !== 0 && item.processing_fee_payment !== 0){
                  item.processing_fees = item.processing_fee_payment + item.processing_fee_wallkit;
                }else{
                  item.processing_fees = item.fee + item.connect_fee;
                }
                item.price = item.purchases.reduce((price, p) => price + p.price, 0);
                return item;
              })
            }

            return {
              data: items,
              count: data.data.paginator.total_items
            }
          }
        },
      }
    },
    mounted() {
      Event.$on('vue-tables.transactionsTable.loaded', ({data}) => {
        this.totalRecordsCount = data.paginator.total_items;
        this.filteredAmount = data.filtered_amount
      });
    },
    methods: {
      filter(params) {
        this.params = params;
        Event.$emit('vue-tables.transactionsTable.filter::custom', params)
      }
    },
    destroyed() {
      Event.$off('vue-tables.transactionsTable.loaded');
    }
  }
</script>
